<!--  -->
<template>
  <ul class="skeketon">
    <li class="skeketon-item"  v-for="i in 3" :key="i">
      <div class="skeketon-item-top">
        <span class="w178 h16"></span>
        <span class="w64 h16"></span>
      </div>
      <div class="skeketon-item-center">
        <div class="skeketon-item-center-left">
          <span></span>
          <span></span>
        </div>
        <div class="skeketon-item-center-right"></div>
      </div>
      <div class="skeketon-item-bottom">
        <div class="skeketon-item-bottom-left"></div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  &-item{
    width: 100%;
    height: 172px;
    padding: 10px;
    background: var(--APP_skeleton_background_color);
    box-sizing: border-box;
    margin-bottom: 8px;
    &-top{
      display: inline-flex;
      height: 16px;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 12px;
      >span{
        display: inline-block;
        background: var(--APP_skeleton_color);
      }
    }
    &-center{
      width: 100%;
      height: 64px;
      padding: 15px 0;
      overflow: hidden;
      &-left{
        height: 64px;
        float: left;
        >span{
          display: inline-block;
          height: 64px;
          width: 64px;
          margin-right: 25px;
          background:  var(--APP_skeleton_color);
        }
      }
      &-right{
        height: 64px;
        width: 64px;
        float: right;
        background:  var(--APP_skeleton_color);
      }
    }
    &-bottom{
      width: 100%;
      height: 16px;
      margin-top: 10px;
      &-left{
        width: 153px;
        height: 16px;
        background: var(--APP_skeleton_color);
      }
    }
  }
}

</style>
